module.exports = __webpack_public_path__ + "static/media/dashboardSimple2_en.1c71f5d3.png";